function NightAuditRoomDates() {
    return (
      <>
        <div className="font-bold text-lg mb-16">NightAuditRoomDates</div>
      </>
    );
  }
  
  export default NightAuditRoomDates;